import { appDataReducerPaginationAndSearch } from './reducerMetadata';

export function AppDataReducerTemplates(state, action) {
    const meta = appDataReducerPaginationAndSearch(action.templates.message.meta);

    const templates = action.templates.message.data.map((template) => ({
        id: template.id,
        name: template.name,
        accessType: template.access_type,
        applicationType: template.application_type,
        type: template.type,
        ipWhitelist: template.ip_whitelist,
    }));

    return {
        meta,
        items: templates,
    };
}

export function AppDataReducerTemplate(state, action) {
    const templateDetail = action.template.message.data;
    let templateRoutes = [];

    if (typeof templateDetail.routes !== 'undefined' && templateDetail.routes !== null) {
        templateRoutes = templateDetail.routes.map((route) => ({
            route: route.route,
            required: route.required,
        }));
    }

    let ipWhitelist = templateDetail.ip_whitelist;
    if (ipWhitelist !== null) {
        ipWhitelist = templateDetail.ip_whitelist.map((ip) => ({
            name: ip,
        }));
    }

    return {
        id: templateDetail.id,
        name: templateDetail.name,
        type: templateDetail.type,
        accessType: templateDetail.access_type,
        applicationType: templateDetail.application_type,
        applicationInternalCode: templateDetail?.application_internal_code,
        routes: templateRoutes,
        ipWhitelist: ipWhitelist,
    };
}

function mapRoutingSlug(route, categorizedRoutingSlugs, initialSelectedRoutes, requiredRoutes, configuredRoutingSlugs) {
    let isDuplicate = false;

    // Add category to the object if it doesn't exist yet
    if (typeof categorizedRoutingSlugs[route.category] === 'undefined') {
        categorizedRoutingSlugs[route.category] = [];
        initialSelectedRoutes[route.category] = [];
        requiredRoutes[route.category] = [];

        // Prevent duplicate slugs
        categorizedRoutingSlugs[route.category].forEach((alreadySavedSlug) => {
            if (alreadySavedSlug.name === route.slug) {
                isDuplicate = true;
            }
        });
    }

    if (!isDuplicate) {
        if (typeof configuredRoutingSlugs[route.slug] === 'undefined') {
            categorizedRoutingSlugs[route.category].push({
                name: route.slug,
                description: route.description,
                category: route.category,
                selected: false,
                required: null,
            });
        } else {
            const selectedRoute = {
                name: route.slug,
                description: route.description,
                category: route.category,
                selected: true,
                required: configuredRoutingSlugs[route.slug].required,
            };
            categorizedRoutingSlugs[route.category].push(selectedRoute);

            // Keep a seperate collection of the selected routes, so these can be checked when loading in the edit page
            initialSelectedRoutes[route.category][route.slug] = selectedRoute;

            // Keep a seperate collection of the required routes, so these can be checked and are immutable when using a template
            // at the new/edit page of a API-user
            if (configuredRoutingSlugs[route.slug].required) {
                requiredRoutes[route.category].push(route.slug);
            }
        }
    }
    return categorizedRoutingSlugs;
}

export function AppDataReducerTemplateWithAllRoutingSlugs(state, action) {
    const templateDetail = action.template.message.data;
    const configuredRoutingSlugs = [];
    const categorizedRoutingSlugs = {};
    const initialSelectedRoutes = {};
    const requiredRoutes = {};
    if (typeof templateDetail?.routes !== 'undefined' && templateDetail?.routes !== null) {
        for (const routingSlug of templateDetail.routes) {
            configuredRoutingSlugs[routingSlug.route] = routingSlug;
        }
    }

    action.slugs.message.data.map((route) =>
        mapRoutingSlug(route, categorizedRoutingSlugs, initialSelectedRoutes, requiredRoutes, configuredRoutingSlugs),
    );

    return {
        id: templateDetail?.id,
        name: templateDetail?.name,
        type: templateDetail?.type,
        accessType: templateDetail?.access_type,
        applicationType: templateDetail?.application_type,
        applicationInternalCode: templateDetail?.application_internal_code,
        routes: categorizedRoutingSlugs,
        initialSelectedRoutes: initialSelectedRoutes,
        requiredRoutes: requiredRoutes,
        ipWhitelist: templateDetail?.ip_whitelist,
    };
}
